import React from "react";

function TMJPain() {
  return <div>TMJPain</div>;
}

export default TMJPain;
